import { styled } from '@mui/material/styles'
import { alpha, Box } from '@mui/material'

export const ZoomContainer = styled(Box)(({ theme }) => ({
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  boxShadow: `0 12px 16px -4px ${alpha(theme.palette.common.black, 0.24)}`,
  backgroundColor: theme.palette.common.white,
  borderRadius: '20px',
  border: 'solid 1px',
  borderColor: '#EFEFEF',
  overflow: 'hidden',
  width: 40,
  '&.globalsite': {
    position: 'absolute',
    bottom: 24,
    right: 24,
  }
}))

interface ZoomButtonContainerProps {
  disabled?: boolean
  position: 'top' | 'bottom'
  mapsView: string
}

export const ZoomButtonContainer = styled('div')<ZoomButtonContainerProps>(({ theme, disabled, position, mapsView }) => ({
  color: '#464646',
  cursor: disabled ? 'not-allowed' : 'pointer',
  backgroundColor: 'white',
  minHeight: '40px',
  minWidth: '40px',
  maxHeight: '40px',
  maxWidth: '40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: mapsView === 'global' ? '20px' : '25px',
  fontWeight: 400,
  opacity: disabled ? 0.5 : 1,
  borderRadius: position === 'top' ? '20px 20px 0 0' : '0 0 20px 20px',
  transition: 'color 0.2s ease',
  '&:hover': {
    color: !disabled ? theme.palette.primary.main : '#464646'
  }
}))